export default __webpack_public_path__ + "static/media/regulatory--priority-over-oncoming-vehicles--g1.db6faf10.png";